<template>
	<div class="videolist">
		<div class="breadcrumb">动作库管理 > 动作库列表</div>
		<div class="searchBtn" style="border:none;display:flex">
	      	<el-button size='small' type="primary" @click="add" plain>创建动作库</el-button>
	      	<el-button size='small' type="warning" @click="edit" plain>编辑</el-button>
	      	<el-button size='small' type="danger" @click="del" plain >删除</el-button>
	      	<el-select v-model="motionKindId" placeholder="请选择动作类型" style="margin:0 10px">
			    <el-option
			      v-for="item in getMotionKindList"
			      :key="item.id"
			      :label="item.name"
			      :value="item.id">
			    </el-option>
			</el-select>
	    	<el-button type="primary" @click="search_mine">搜索</el-button>
	    </div>

	    <div class="main">
	      	<template>
	        	<el-table
	        		v-loading="loading"
	          		ref="multipleTable"
	          		:data="tableData"
	          		highlight-current-row
	          		tooltip-effect="dark"
	          		style="width: 100%"
	          		@current-change="handleCurrentChange">
		          	<el-table-column prop="title" label="动作名称"></el-table-column>
		          	<el-table-column prop="motionKindName" label="动作类型"></el-table-column>
		          	<el-table-column prop="motionVideoUrl" label="视频">
				    	<template slot-scope="scope">
				    		<el-button type="primary" size="small" @click="watchVideo(scope.row.motionVideoUrl)" v-if="scope.row.motionVideoUrl">观看视频</el-button>
				    	</template>
				    </el-table-column>
				    <el-table-column prop="introduce" label="介绍" show-overflow-tooltip></el-table-column>
				    <el-table-column prop="sort" label="排序"></el-table-column>
		          	<el-table-column prop="createTime" :formatter="this.global.dateFormat" label="创建时间"></el-table-column>	
	        	</el-table>
	      	</template>
      		<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination
		          	@current-change="handleCurrentChangePage"
		          	:current-page="pageNum"
		          	:page-size="limit"
		          	layout="total, prev, pager, next, jumper"
		          	:total="totalPage"
	        	></el-pagination>
      		</div>
    	</div>

    	<el-dialog title="视频" :visible.sync="dialogVisible2" width="35%" :before-close="handleClose">
	    	<div style="max-height:500px;max-width:100%; text-align:center">
	      		<video :src="videoUrl" controls="controls" loop="-1" style="max-height:500px;max-width:100%;"></video>
	      	</div>
	    </el-dialog>

    	<!-- 弹框 -->
    	<el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" status-icon label-width="200px">
        		<el-form-item label="动作名称" prop="title">
          			<el-input v-model="ruleForm.title" placeholder="请输入8个字以内"  style="width: 80%;"></el-input>
        		</el-form-item>
        		<el-form-item label="动作类型" prop="motionKindId">
				    <el-select v-model="ruleForm.motionKindId" placeholder="请选择动作类型" style="width: 80%;" >
				    	<el-option :label="item.name" :value="item.id" :key="item.id" v-for="item in getMotionKindList"></el-option>
				    </el-select>	
        		</el-form-item>
        		<el-form-item label="上传视频" class="video-upload" prop="motionVideoUrl">
	          		<el-input v-model="ruleForm.motionVideoUrl" placeholder style="width: 80%;"></el-input>
	          		<el-upload class="avatar-uploader" :action="tmpFiles" accept=".mp4, .qlv, .qsv, .ogg, .flv, .avi, .wmv, .rmvb" :show-file-list="false" :before-upload="beforeUploadVideo" :on-success="handleVideoSuccess" :on-progress="uploadVideoProcess" :headers="{'yj-admin-token':token}">
	            		<video v-if="ruleForm.motionVideoUrl !='' && videoFlag == false" :src="ruleForm.motionVideoUrl" width="100%" height="100%" controls="controls">您的浏览器不支持视频播放</video>
			            <i v-else-if="ruleForm.motionVideoUrl =='' && videoFlag == false" class="el-icon-plus avatar-uploader-icon"></i>
			            <el-progress v-if="videoFlag == true" type="circle" :percentage="videoUploadPercent" style="margin-top:30px"></el-progress>
	          		</el-upload>
	        	</el-form-item>
	        	<el-form-item label="视频时长" prop="duration">
	        		<div style="display:flex;width:80%">
	        			<el-input v-model="ruleForm.minute" placeholder="请输入分" style="width: 80%;" @change="minute" @input="portInput($event)"></el-input>&nbsp;分&nbsp;&nbsp;
		          		<el-input v-model="ruleForm.second" placeholder="请输入秒" style="width: 80%;" @change="minute" @input="portInput($event)"></el-input>&nbsp;秒
	        		</div>
		          	
		        </el-form-item>

	        	<el-form-item label="上传视频封面" prop="motionCoverUrl">
		          	<el-input v-model="ruleForm.motionCoverUrl" placeholder style="width: 80%;"></el-input>
		          	<el-upload class="avatar-uploader" :action="tmpFiles2" :show-file-list="false" :headers="{'yj-admin-token':token}" :on-success="handleAvatarSuccess" >
		            	<img v-if="ruleForm.motionCoverUrl" :src="ruleForm.motionCoverUrl" class="avatar" />
		            	<i v-else class="el-icon-plus avatar-uploader-icon"></i>
		          	</el-upload>
                <p style="font-size:12px;color:red;">图片规格：240px*136px,格式：png、jpg</p>
		        </el-form-item>

		        <el-form-item label="展示">
				    <el-radio-group v-model="ruleForm.screenDirection">
				      <el-radio :label="1">横屏</el-radio>
				      <el-radio :label="2">竖屏</el-radio>
				    </el-radio-group>
				</el-form-item>

		        <el-form-item label="观看条件">
				    <el-radio-group v-model="ruleForm.viewLimit">
				      <el-radio :label="1">会员</el-radio>
				      <el-radio :label="0">非会员</el-radio>
				    </el-radio-group>
				</el-form-item>

        		<el-form-item label="介绍">
		          	<el-input type="textarea" placeholder="请输入介绍" v-model="ruleForm.introduce" style="width:80%" :rows="4"></el-input>
		        </el-form-item>
        		<el-form-item label="排序">
          			<el-input v-model="ruleForm.sort" placeholder="请输入排序"  style="width: 80%;"></el-input>
        		</el-form-item>
      		</el-form>
      		<span slot="footer" class="dialog-footer">
        		<el-button @click="dialogVisible = false">取 消</el-button>
        		<el-button type="primary" @click="onSubmit('ruleForm')">确 定</el-button>
      		</span>
    	</el-dialog>

	</div>
</template>

<script>
export default {
  mounted() {
    this.getMotionKind(); 
    this.init();
  },
  data() {
    return {
      token:window.localStorage.getItem('token'),
      tmpFiles2: process.env.API_ROOT + '/tmpFiles',
      tmpFiles: process.env.API_ROOT + '/tmpFiles?type=1',
      getMotionKindList: [],
      videoFlag: false, //刚开始的时候显示为flase
      videoUploadPercent: '0%', //进度条刚开始的时候为0%
      motionKindId: '',

      tableData: [],
      pageNum: 1,
      limit: 10,
      totalPage: 10,
      currentRow: '',
      dialogVisible: false,
      loading: true,
      ruleForm: {
        motionVideoUrl: '',
        motionCoverUrl: '',
        motionKindId: '',
        duration: '',
        viewLimit: 1,
        screenDirection: 1
      },
      rules: {
        title: [
          { required: true, message: '请输入动作名称', trigger: 'blur' },
          { min: 1, max: 8, message: '长度在8个字以内', trigger: 'blur' }
        ],
        motionKindId: [{ required: true, message: '请选择动作类型', trigger: 'change' }],
        motionVideoUrl: [{ required: true, message: '请上传视频', trigger: 'blur' }],
        motionCoverUrl: [{ required: true, message: '请上传视频封面', trigger: 'blur' }],
        duration: [{ required: true, message: '请输入视频时长', trigger: 'blur' }]
      },
      dialogVisible2: false,
      videoUrl: ''
    };
  },
  methods: {
    portInput(e) {
      this.$forceUpdate();
    },
    minute(val) {
      if (this.ruleForm.minute && this.ruleForm.second) {
        this.ruleForm.duration = Number(this.ruleForm.minute) * 60 + Number(this.ruleForm.second);
      }
      if (this.ruleForm.minute && !this.ruleForm.second) {
        this.ruleForm.duration = Number(this.ruleForm.minute) * 60;
      }
      if (!this.ruleForm.minute && this.ruleForm.second) {
        this.ruleForm.duration = Number(this.ruleForm.second);
      }
    },
    getMotionKind() {
      this.$get('/motion/getMotionKind').then(res => {
        console.log(res);
        if (res.code == 0) {
          this.getMotionKindList = res.data;
        } else {
          this.$message({
            message: res.message,
            type: 'warning'
          });
          return false;
        }
      });
    },
    watchVideo(url) {
      if (url) {
        this.dialogVisible2 = true;
        this.videoUrl = url;
      }
    },
    add(row) {
      this.$refs.multipleTable.setCurrentRow(row);
      if (this.$refs.ruleForm != undefined) {
        this.$refs.ruleForm.resetFields();
        this.ruleForm = {
          motionVideoUrl: '',
          motionCoverUrl: '',
          motionKindId: '',
          viewLimit: 1
        };
      }
      this.dialogVisible = true;
      this.currentRow = '';
    },
    edit() {
      if (this.currentRow.id) {
        this.ruleForm = this.currentRow;
        if (this.ruleForm.duration > 60) {
          this.ruleForm.minute = parseInt(this.ruleForm.duration / 60);
          this.ruleForm.second = this.ruleForm.duration - this.ruleForm.minute * 60;
        } else {
          this.ruleForm.second = this.ruleForm.duration;
        }
        this.dialogVisible = true;
      } else {
        this.dialogVisible = false;
        this.$message({
          message: '请选择信息',
          type: 'warning'
        });
        return false;
      }
    },
    del() {
      if (this.currentRow.id) {
        this.$confirm('确定要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var data = { id: this.currentRow.id };
          this.$post('/motion/delMotionDetail', JSON.stringify(data)).then(res => {
            if (res.code == 0) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.currentRow = '';
              this.pageNum = 1;
              this.init();
            } else {
              this.$message({
                message: res.message,
                type: 'warning'
              });
              return false;
            }
          });
        });
      } else {
        this.$message({
          message: '请选择信息',
          type: 'warning'
        });
        return false;
      }
    },
    search_mine() {
      this.pageNum = 1;
      this.init();
    },
    init() {
      //初始化表格数据
      var params = {
        pageNum: this.pageNum,
        limit: this.limit,
        motionKindId: this.motionKindId
      };
      this.$get('motion/getMotionDetailList', params).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.list;
          this.totalPage = res.data.total;
          this.loading = false;
        } else {
          this.$message({
            message: res.message,
            type: 'warning'
          });
          return false;
        }
      });
    },
    //选择需要修改的权限
    handleCurrentChange(val) {
      if (val) {
        this.currentRow = val;
      }
    },
    //当前页数
    handleCurrentChangePage(val) {
      this.pageNum = val;
      this.init();
    },
    //弹框关闭按钮
    handleClose(done) {
      if (this.$refs.ruleForm != undefined) {
        //this.$refs.ruleForm.resetFields();
        this.$refs.ruleForm.clearValidate();
        this.ruleForm = {
          // motionVideoUrl:'',
          // motionCoverUrl:'',
          // motionKindId:"",
          // viewLimit:1
        };
      }
      done();
    },
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.ruleForm);
          //return false
          this.$post('/motion/addMotionDetail', JSON.stringify(this.ruleForm)).then(res => {
            if (res.code == 0) {
              this.$message({
                message: this.ruleForm.id ? '修改成功' : '添加成功',
                type: 'success'
              });
              this.$refs.ruleForm.resetFields();
              this.currentRow = '';
              this.pageNum = 1;
              this.init();
              this.dialogVisible = false;
            } else {
              this.$message({
                message: res.message,
                type: 'warning'
              });
              return false;
            }
          });
        }
      });
    },
    //视频
    beforeUploadVideo(file) {
      const ismp4 = file.type === 'video/mp4';
      var that = this;
      if (!ismp4) {
        that.$message.error('上传视频只能是 mp4 格式!');
      }
      return ismp4;
    },
    handleVideoSuccess(response, file, fileList) {
      //视频上传成功之后返回视频地址
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      this.ruleForm.motionVideoUrl = response.data.url;
    },
    uploadVideoProcess(event, file, fileList) {
      //视频上传的时候获取上传进度传给进度条
      this.videoFlag = true;
      this.videoUploadPercent = parseInt(file.percentage);
      //console.log(this.videoUploadPercent);
    },
    //选择图片成功
    handleAvatarSuccess(res, file) {
      if (res.data.url) {
        this.ruleForm.motionCoverUrl = res.data.url;
      }
    }
  }
};
</script>
<style scoped>
::deep .avatar-uploader-icon {
  width: 108px;
  line-height: 108px;
}
</style>



// WEBPACK FOOTER //
// src/views/actionLibraryList/index.vue